import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  fallbackSrc: string;
  style?:string
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, alt, fallbackSrc , style }) => {
  const [imgSrc, setImgSrc] = useState<string>(src);

  const handleError = () => {
    setImgSrc(fallbackSrc);
  };

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={imgSrc || '/assets/logo/noimage.png'}
      alt={alt}
      onError={handleError}
      className={style}
    />
  );
};

export default ImageWithFallback;